import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/bg.jpg';
import banner8 from '../assets/banner8.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";

export default function HomeBanner3(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					padding: "0",
					backgroundImage: `url(${banner5})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				
				<div className="container">
					<div className="row" >

						<div className="col-md-12 mb-3">
							
							<div
							>
								<h6
									className="main-section-title"
								>
									FPADI Key Focus Areas

								</h6>

								<p
									style={{
										fontSize: "18px",
										textAlign: "center"
									}}
								>
									Empowering Communities for Sustainable Development, Eradicating Poverty:
								</p>

								
							</div>

						</div>

						<div className="col-md-12">
							
							<div className="row">

								<div 
									className="col-md-3 mt-3"
									style={{
										overflow: "hidden"
									}}
								>
									<div>
										<img src={banner1} style={{width: "100%"}}
									/>
										<div className="p-3 bg-light">
											
											<h6 className="mt-2">
												<span className="bg-extra py-1 px-2 rounded">Environments</span><br/><br/>
												We protect our environment and advocate for Climate change.
											</h6>
										</div>
									</div>
								</div>

								<div 
									className="col-md-3 mt-3"
									style={{
										overflow: "hidden"
									}}
								>
									<div>
										<img src={banner3} style={{width: "100%"}}
									/>
										<div className="p-3 bg-light">
											
											<h6 className="mt-2">
												<span className="bg-extra py-1 px-2 rounded">Agriculture</span><br/><br/>
												 We strive for sustainable agriculture and sustainable livelihoods.
											</h6>
										</div>
									</div>
								</div>

								<div 
									className="col-md-3 mt-3"
									style={{
										overflow: "hidden"
									}}
								>
									<div>
										<img src={banner8} style={{width: "100%"}}
									/>
										<div className="p-3 bg-light">
											
											<h6 className="mt-2">
												<span className="bg-extra py-1 px-2 rounded">Knowledge</span><br/><br/>
												We provide skills, knowledge and resources to empower women & youth.
											</h6>
										</div>
									</div>
								</div>

								<div 
									className="col-md-3 mt-3"
									style={{
										overflow: "hidden"
									}}
								>
									<div>
										<img src={banner4} style={{width: "100%"}}
									/>
										<div className="p-3 bg-light">
											
											<h6 className="mt-2">
												<span className="bg-extra py-1 px-2 rounded">Equality</span><br/><br/>
												  We promote Social Inclusion, Gender balance and Gender Equality.
											</h6>
										</div>
									</div>
								</div>

								<div className="col-md-6 my-5">
									<button
										className="btn btn-padded btn-secondary"
										style={{
											margin: "10px",

										}}
										onClick={() => {
											appContext.navTo({
												item: 'about_us'
											})
										}}
									>
										Learn More About Us...
									</button>
								</div>

							</div>

						</div>

						
					</div>

				
				</div>
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
